import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { LatestEventType } from '../utils/utilTypes';

type StateType = {
  latestEvent: LatestEventType | null;
  setLatestEvent: (event: LatestEventType) => void;
};

export const useLatestEventSlice = create<StateType>()(
  devtools(
    (set) => ({
      latestEvent: null,
      setLatestEvent: (event) =>
        set({ latestEvent: event }, false, 'setLatestEvent'),
    }),
    { name: 'Latest Event Store' }
  )
);
